import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'

import { ChannelSourcesViewService } from '../../data/services/view/channel-sources-view.service'

@Component({
  selector: 'app-channel-badge',
  templateUrl: './channel-badge.component.html',
  styleUrls: ['./channel-badge.component.scss'],
})
export class ChannelBadgeComponent implements OnInit, OnChanges {
  @Input() channelKey: string | null = null
  @Output() reassign = new EventEmitter<void>()

  channelLabel = 'Sin canal'

  constructor(private channels: ChannelSourcesViewService) {}

  ngOnInit(): void {
    this.resolve()
  }

  ngOnChanges(): void {
    this.resolve()
  }

  private resolve(): void {
    this.channelLabel = this.channelKey ? this.channels.getByKey(this.channelKey)?.label ?? this.channelKey : 'Sin canal'
  }
}
